<template>
	<div id="app">
		<router-view />
	</div>
</template>
<script>
	import {configs } from '@/config'
	export default {
		data() {
			return {
				
			}
		},
		created() {

		},
		methods: {
			
		}
	}
</script>

<style lang="scss">
	html,body{
		width: 100%;
		height: 100%;
		padding: 0;
		margin: 0;
	}
	#app {
		font-family: Avenir, Helvetica, Arial, sans-serif,"宋体";
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
		min-height: 100%;
		height: 100%;
		// font-family:"等线";
		// font-weight: 600;
	}

	nav {
		padding: 30px;

		a {
			font-weight: bold;
			color: #2c3e50;

			&.router-link-exact-active {
				color: #4baf4f;
			}
		}
	}
	.w-1200{
		width: 1200px;
	}
	li{
		list-style: none;
	}
	.primary-btn{
		outline: none;
		border: #4baf4f solid 1px;
		background: #4baf4f;
		color: #fff;
		font-size: 16px;
		height: 50px;
		line-height: 50px;
		// padding: 12px 0;
		width: 100%;
		border-radius: 50px;
		cursor: pointer;
	}
	.el-button{
		font-size: 16px!important;
	}
	.el-form{
		font-size: 24px!important;
	}
	.el-form-item__label {
		font-size: 16px !important;
	}
	.el-input__inner{
		font-size: 15px !important;
	}
	.el-message-box__status{
		color: #4baf4f !important;
		top: 15px!important;
	}
	.el-cascader-menu__list{
		max-width: 250px!important;
	}
	.el-textarea__inner{
		font-family: Avenir, Helvetica, Arial, sans-serif,"宋体";
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		font-size: 16px;
	}
	.banner .el-carousel__item:before{
	    content: "";
	    display: block;
	    position: absolute;
	    bottom: 0;
	    left: 0;
			z-index: 1;
			// transform: translateX(-50%);
	    width: 100%;
	    height: 100%;
	    background: rgba(75,175,79,0.5);
			// style="background-color: rgba(75,175,79,0.8);"
	}
	.banner .el-carousel__item .w-1200{
		z-index: 2;
	}
</style>